import React from 'react'
import {Icon} from '@chakra-ui/react'

const GridIconB = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <rect
                x="2.5"
                y="8.50024"
                width="13.68"
                height="23.23"
                stroke="currentColor"
                strokeWidth="3"
            />
            <rect x="22.6201" y="14.3003" width="6.83" height="11.6" fill="currentColor" />
            <rect x="32.1699" y="14.3003" width="6.83" height="11.6" fill="currentColor" />
        </Icon>
    )
}

export default GridIconB
